import { createContext, useCallback, useEffect, useState } from 'react';

type TitleParam = {
    mainTitle: string,
    firstSubTitle: string,
    secondSubTitle: string,
}

export type TitleParamContext = {
    param: TitleParam;
    setParamData: (param: TitleParam) => void;
}

const defaultContext: TitleParamContext = {
    param: { mainTitle: "", firstSubTitle: "", secondSubTitle: "" },
    // �����l���쐬���邪�Aeslint�Ɉ���������
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setParamData: () => { },
};

export const TitleParamContext = createContext<TitleParamContext>(defaultContext);

export const TitleContext = (): TitleParamContext => {
    const [param, setParam] = useState<TitleParam>({ mainTitle: "", firstSubTitle: "", secondSubTitle: "" });

    const setParamData = useCallback((current: TitleParam): void => {
        setParam(current);
    }, []);

    useEffect(() => {
    }, []);

    return {
        param,
        setParamData
    }
}